import { Link } from "react-router-dom";
import { Badges, P, SVG } from "../../../AbstractElements";
import { Href } from "../../../utils/Constant";
// import { Rating } from "react-simple-star-rating";
// import { dynamicImage } from "../../../Service";
import { TableColumn } from "react-data-table-component";
import { RfidCardListTableDataColumnType, RfidCardListTableOffer } from "../../../Types/Application/Ecommerce/Ecommerce";
import Swal from "sweetalert2";
import api from "../../../utils/api";

export const RfidCardListTableData = [
  {
    rfid_card_no: "Adult122",
    card_status: "Active",
  },
  {
    rfid_card_no: "Child222",
    card_status: "Active",
  },
];

// const RfidCardListTableAction = () => {
//   return (
//     <div className="product-action">
//       <Link to={Href}>
//         <SVG iconId="edit-content" style={{ fill: 'blue' }} />
//       </Link>
//       <SVG iconId="trash1" style={{ fill: 'red' }}/>
//     </div>
//   );
// };

const handleDelete = async (id: number) => {
  // Your delete logic here (API call, state update, etc.)
  // console.log("Deleting ID:", id);
  try {
    await api.delete(`/api/RFIDCardMaster/DeleteRFIDCardMaster?rfid=${id}`);
    Swal.fire('Deleted!', 'RFID Card has been deleted.', 'success');

    // Optional: refresh the list
    // setTicketListTableDatas((prev) => prev.filter((item) => item.adultPlanId !== id));
  } catch (error) {
    Swal.fire('Error!', 'Failed to delete the RFID Card.', 'error');
    console.error("Delete error:", error);
  }
};

interface ProductListTableActionProps {
  rfId: any;
  onDelete: (id: number) => void;
}

export const RfidCardListTableAction: React.FC<ProductListTableActionProps> = ({ rfId, onDelete }) => {
  const editUrl = `/rfid_card/edit/${rfId}`;

  const handleDeleteClick = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this RFID Card!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        onDelete(rfId);
      }
    });
  };

  return (
    <div className="product-action d-flex gap-2">
      <Link to={editUrl}>
        <SVG iconId="edit-content" style={{ fill: 'blue' }} />
      </Link>
      <button className="btn btn-sm" onClick={handleDeleteClick}>
        <SVG iconId="trash1" style={{ fill: 'red' }} />
      </button>
    </div>
  );
};

export const RfidCardListTableOfferComponent: React.FC<RfidCardListTableOffer> = ({ title }) => {
  return (
    <div className="product-names my-2">
      <P>{title}</P>
    </div>
  );
};

export const RfidCardListTableStatus :React.FC<RfidCardListTableOffer> = ({ title }) => {
  return (
    <Badges color="" className={`badge-light-${title === "Active" ? "secondary" : "primary" }`}>{title}</Badges>
  );
};

export const RfidCardListTableDataColumn: TableColumn<RfidCardListTableDataColumnType>[] = [
  {
    name: "RFID Card No.",
    cell: (row) => <RfidCardListTableOfferComponent title={String(row.rfid_card_no)}/>,
    sortable: true,
    grow: 2,
  },
  {
    name: "Card Status",
    cell: (row) =>  <RfidCardListTableStatus title={row.card_status} />,
  },
  {
    name: "Action",
    cell: (row) => <RfidCardListTableAction rfId={row.rfId} onDelete={handleDelete} />,
  },
];

  export const filtersData = [
    {
      name: "Choose RFID Card",
      options: ["Adult122", "Child222"],
    },
    {
      name: "Status",
      options: ["Active", "Inactive"],
    },
  ];